import { MotionLink, MotionLinkProps } from "@cc/motion-components";
import { Box, BoxProps } from "@mui/material";

interface SocialIconProps extends Partial<MotionLinkProps> {
  SvgIconProps?: Omit<BoxProps<"svg">, "children">;
}

export const FacebookIcon = (props: SocialIconProps) => {
  const { SvgIconProps = {}, variant = "contained", ...restLogoProps } = props;

  return (
    <MotionLink href={"#"} disableRipple {...restLogoProps}>
      <Box
        component={"svg"}
        xmlns="http://www.w3.org/2000/svg"
        width={42}
        height={41}
        viewBox="0 0 42 41"
        fill={variant === "contained" ? "white" : "none"}
        {...SvgIconProps}
      >
        <path
          opacity="0.5"
          d="M40.9999 0.5H0.999939V40.5H40.9999V0.5Z"
          stroke={variant === "text" ? "transparent" : "#FDFEFF"}
          strokeMiterlimit="10"
        />
        <path
          d="M17.8536 32.969H22.8741V20.3914H26.3799L26.7522 16.1757H22.8741V13.7784C22.8741 12.7829 23.0733 12.3938 24.0341 12.3938H26.7522V8.02173H23.2724C19.5329 8.02173 17.8536 9.66643 17.8536 12.8173V16.1757H15.2395V20.4438H17.8536V32.969Z"
          fill={variant === "contained" ? "#326ccf" : "white"}
        />
      </Box>
    </MotionLink>
  );
};

export const TwitterIcon = (props: SocialIconProps) => {
  const { SvgIconProps = {}, variant = "contained", ...restLogoProps } = props;

  return (
    <MotionLink href={"/"} disableRipple {...restLogoProps}>
      <Box
        component={"svg"}
        xmlns="http://www.w3.org/2000/svg"
        width={42}
        height={41}
        viewBox="0 0 42 41"
        fill={variant === "contained" ? "white" : "none"}
        {...SvgIconProps}
      >
        <path
          opacity="0.5"
          d="M40.9999 0.5H0.999939V40.5H40.9999V0.5Z"
          stroke={variant === "text" ? "transparent" : "#FDFEFF"}
          strokeMiterlimit="10"
        />
        <path
          d="M10.3655 27.1777C12.2958 28.4155 14.5897 29.1346 17.048 29.1346C25.1502 29.1346 29.7207 22.296 29.4437 16.1588C30.292 15.5442 31.0364 14.7735 31.6164 13.8993C30.8373 14.2455 29.989 14.4793 29.1148 14.5831C30.015 14.0465 30.7075 13.1895 31.0277 12.168C30.1881 12.6701 29.2533 13.0343 28.2578 13.2247C27.4614 12.3764 26.3274 11.8477 25.0723 11.8477C22.2591 11.8477 20.1902 14.4708 20.8221 17.2062C17.1952 17.0244 13.9837 15.2849 11.8284 12.6448C10.6857 14.6097 11.2398 17.1715 13.1788 18.4699C12.4603 18.444 11.7938 18.2536 11.2051 17.9247C11.1619 19.9416 12.6075 21.8373 14.7023 22.2528C14.0877 22.4172 13.4125 22.4604 12.7373 22.3305C13.2913 24.0618 14.9013 25.3256 16.8143 25.3602C14.9792 26.7971 12.668 27.4375 10.3569 27.1692L10.3655 27.1777Z"
          fill={variant === "contained" ? "#326ccf" : "white"}
        />
      </Box>
    </MotionLink>
  );
};

export const YouTubeIcon = (props: SocialIconProps) => {
  const { SvgIconProps = {}, variant = "contained", ...restLogoProps } = props;

  return (
    <MotionLink href={"/"} disableRipple {...restLogoProps}>
      <Box
        component={"svg"}
        xmlns="http://www.w3.org/2000/svg"
        width={42}
        height={41}
        viewBox="0 0 42 41"
        fill={variant === "contained" ? "white" : "none"}
        {...SvgIconProps}
      >
        <path
          opacity="0.5"
          d="M40.9999 0.5H0.999939V40.5H40.9999V0.5Z"
          stroke={variant === "text" ? "transparent" : "#FDFEFF"}
          strokeMiterlimit="10"
        />

        <path
          d="M31.9287 14.9728C31.6691 13.986 30.8899 13.207 29.9118 12.9474C28.1373 12.4713 21.0047 12.4714 21.0047 12.4714C21.0047 12.4714 13.872 12.4713 12.0975 12.9474C11.1193 13.207 10.3403 13.986 10.0806 14.9728C9.60456 16.7646 9.60452 20.4953 9.60452 20.4953C9.60452 20.4953 9.60456 24.226 10.0806 26.0178C10.3403 27.0046 11.1193 27.7835 12.0975 28.0432C13.872 28.5193 21.0047 28.52 21.0047 28.52C21.0047 28.52 28.1373 28.5193 29.9118 28.0432C30.8899 27.7835 31.6691 27.0046 31.9287 26.0178C32.4048 24.226 32.4048 20.4953 32.4048 20.4953C32.4048 20.4953 32.4048 16.7646 31.9287 14.9728ZM18.6675 23.8884V17.1021L24.6316 20.4953L18.6675 23.8884Z"
          fill={variant === "contained" ? "#326ccf" : "white"}
        />
      </Box>
    </MotionLink>
  );
};

export const InstagramIcon = (props: SocialIconProps) => {
  const { SvgIconProps = {}, variant = "contained", ...restLogoProps } = props;

  return (
    <MotionLink href={"/"} disableRipple {...restLogoProps}>
      <Box
        component={"svg"}
        xmlns="http://www.w3.org/2000/svg"
        width={42}
        height={41}
        viewBox="0 0 42 41"
        fill={variant === "contained" ? "white" : "none"}
        {...SvgIconProps}
      >
        <path
          opacity="0.5"
          d="M40.9999 0.5H0.999939V40.5H40.9999V0.5Z"
          stroke={variant === "text" ? "transparent" : "#FDFEFF"}
          strokeMiterlimit="10"
        />
        <path
          d="M20.9954 11.3021C23.9904 11.3021 24.3453 11.3108 25.5312 11.3714C26.6219 11.4234 27.2192 11.6053 27.6173 11.7611C28.1367 11.9689 28.5176 12.211 28.9071 12.6005C29.2966 12.9901 29.539 13.3711 29.7467 13.8905C29.9025 14.2887 30.0843 14.8774 30.1362 15.9768C30.1881 17.1627 30.2055 17.5178 30.2055 20.5128C30.2055 23.5078 30.1968 23.8621 30.1362 25.048C30.0843 26.1386 29.9025 26.736 29.7467 27.1342C29.539 27.6622 29.2966 28.0347 28.9071 28.4242C28.5176 28.8137 28.1454 29.0559 27.6173 29.2636C27.2192 29.4194 26.6305 29.6014 25.5312 29.6533C24.3453 29.7052 23.9904 29.7226 20.9954 29.7226C18.0003 29.7226 17.6454 29.7139 16.4596 29.6533C15.3689 29.6014 14.7716 29.4194 14.3734 29.2636C13.8454 29.0559 13.4732 28.8137 13.0836 28.4242C12.6941 28.0347 12.4518 27.6536 12.244 27.1342C12.0882 26.736 11.9064 26.1473 11.8544 25.048C11.8025 23.8621 11.7852 23.5078 11.7852 20.5128C11.7852 17.5178 11.7938 17.1627 11.8544 15.9768C11.9064 14.8861 12.0882 14.2887 12.244 13.8905C12.4518 13.3711 12.6941 12.9901 13.0836 12.6005C13.4732 12.211 13.8454 11.9689 14.3734 11.7611C14.7716 11.6053 15.3602 11.4234 16.4596 11.3714C17.6454 11.3195 18.0003 11.3021 20.9954 11.3021ZM20.9954 9.28516C17.9484 9.28516 17.5675 9.30254 16.3729 9.35447C15.1784 9.40641 14.3648 9.59735 13.6463 9.87435C12.9105 10.16 12.2873 10.5402 11.6554 11.1635C11.0321 11.7867 10.6513 12.4106 10.3656 13.1551C10.0886 13.8649 9.89819 14.6867 9.84625 15.8812C9.79432 17.0758 9.77694 17.4565 9.77694 20.5035C9.77694 23.5504 9.78566 23.932 9.84625 25.1266C9.89819 26.3211 10.0886 27.1343 10.3656 27.8528C10.6513 28.5885 11.0321 29.2116 11.6554 29.8435C12.2786 30.4667 12.9019 30.8478 13.6463 31.1335C14.3561 31.4105 15.1784 31.6014 16.3729 31.6533C17.5675 31.7053 17.9484 31.7218 20.9954 31.7218C24.0423 31.7218 24.4232 31.7139 25.6177 31.6533C26.8123 31.6014 27.626 31.4105 28.3444 31.1335C29.0802 30.8478 29.7034 30.4667 30.3353 29.8435C30.9585 29.2203 31.3394 28.5972 31.625 27.8528C31.902 27.1429 32.0925 26.3211 32.1445 25.1266C32.1964 23.932 32.2137 23.5504 32.2137 20.5035C32.2137 17.4565 32.2051 17.0758 32.1445 15.8812C32.0925 14.6867 31.902 13.8735 31.625 13.1551C31.3394 12.4193 30.9585 11.7954 30.3353 11.1635C29.712 10.5402 29.0889 10.16 28.3444 9.87435C27.6346 9.59735 26.8123 9.40641 25.6177 9.35447C24.4232 9.30254 24.0423 9.28516 20.9954 9.28516Z"
          fill={variant === "contained" ? "#326ccf" : "white"}
        />
        <path
          d="M20.995 14.7395C17.8182 14.7395 15.2387 17.3185 15.2387 20.4953C15.2387 23.6721 17.8182 26.252 20.995 26.252C24.1718 26.252 26.7514 23.6721 26.7514 20.4953C26.7514 17.3185 24.1718 14.7395 20.995 14.7395ZM20.995 24.2351C18.9262 24.2351 17.2555 22.5641 17.2555 20.4953C17.2555 18.4265 18.9262 16.7565 20.995 16.7565C23.0638 16.7565 24.7344 18.4265 24.7344 20.4953C24.7344 22.5641 23.0638 24.2351 20.995 24.2351Z"
          fill={variant === "contained" ? "#326ccf" : "white"}
        />
        <path
          d="M28.3265 14.5139C28.3265 15.2583 27.7205 15.8647 26.9848 15.8647C26.249 15.8647 25.6345 15.2583 25.6345 14.5139C25.6345 13.7695 26.2403 13.1724 26.9848 13.1724C27.7292 13.1724 28.3265 13.7781 28.3265 14.5139Z"
          fill={variant === "contained" ? "#326ccf" : "white"}
        />
      </Box>
    </MotionLink>
  );
};

export const LinkedInIcon = (props: SocialIconProps) => {
  const { SvgIconProps = {}, variant = "contained", ...restLogoProps } = props;

  return (
    <MotionLink href={"/"} disableRipple {...restLogoProps}>
      <Box
        component={"svg"}
        xmlns="http://www.w3.org/2000/svg"
        width={42}
        height={41}
        viewBox="0 0 42 41"
        fill={variant === "contained" ? "white" : "none"}
        {...SvgIconProps}
      >
        <path
          opacity="0.5"
          d="M40.9999 0.5H0.999939V40.5H40.9999V0.5Z"
          stroke={variant === "text" ? "transparent" : "#FDFEFF"}
          strokeMiterlimit="10"
        />
        <path
          d="M15.2831 17.0159H10.9723V30.9435H15.2831V17.0159Z"
          fill={variant === "contained" ? "#326ccf" : "white"}
        />
        <path
          d="M13.11 15.1891C14.5209 15.1891 15.6635 14.0381 15.6635 12.6185C15.6635 11.1989 14.5209 10.0479 13.11 10.0479C11.699 10.0479 10.5564 11.1989 10.5564 12.6185C10.5564 14.0381 11.699 15.1891 13.11 15.1891Z"
          fill={variant === "contained" ? "#326ccf" : "white"}
        />
        <path
          d="M22.1819 23.6373C22.1819 21.6811 23.0821 20.513 24.8133 20.513C26.3974 20.513 27.1592 21.6291 27.1592 23.6373V30.952H31.4526V22.1318C31.4526 18.401 29.3405 16.5916 26.3801 16.5916C23.4197 16.5916 22.1819 18.8942 22.1819 18.8942V17.0159H18.0443V30.9435H22.1819V23.6289V23.6373Z"
          fill={variant === "contained" ? "#326ccf" : "white"}
        />
      </Box>
    </MotionLink>
  );
};
